// Navigační menu - kompatibilní s Turbo
function initNavigation() {
  const hamburger = document.getElementById('hamburger');
  const fullscreenNav = document.getElementById('fullscreen-nav');
  const navbar = document.querySelector('.navbar');

  if (hamburger && fullscreenNav) {
    // Odstranit existující event listenery
    hamburger.removeEventListener('click', toggleNavigation);
    hamburger.addEventListener('click', toggleNavigation);
  }
}

function toggleNavigation() {
  const fullscreenNav = document.getElementById('fullscreen-nav');
  const hamburger = document.getElementById('hamburger');
  const navbar = document.querySelector('.navbar');
  
  if (fullscreenNav && hamburger) {
    if (fullscreenNav.classList.contains('active')) {
      // Zavřít menu
      fullscreenNav.classList.remove('active');
      hamburger.classList.remove('active');
      if (navbar) {
        navbar.classList.remove('no-bg');
      }
      // Obnovit scrollování dokumentu
      document.body.style.overflow = '';
    } else {
      // Otevřít menu
      fullscreenNav.classList.add('active');
      hamburger.classList.add('active');
      if (navbar) {
        navbar.classList.add('no-bg');
      }
      // Vypnout scrollování dokumentu
      document.body.style.overflow = 'hidden';
    }
  }
}

// Inicializace při načtení stránky
document.addEventListener('DOMContentLoaded', initNavigation);

// Inicializace při Turbo navigaci
document.addEventListener('turbo:load', initNavigation);
